import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import TopMenu from "./components/TopMenu2";
import Slider from "./components/Slider";
import Footer from "./components/Footer2";
import Content from "./components/Content2";

function App() {

    return (
        <>
            <TopMenu/>
            <Slider/>
            <Content/>
        </>
    )
}

export default App
